import { toast } from "react-toastify";
import { logInfo, logWarn, logError } from "../utils/logger";

const defaultConfig = {
  position: "bottom-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

export const infoToast = (evt, payload, msg, config) => {
  logInfo("toast", "infoToast", { evt: evt, payload: payload, msg: msg });
  toast.info(msg, {
    ...defaultConfig,
    ...(config && config.toastId && { toastId: config.toastId }),
    ...(config && config.onOpen && { onOpen: config.onOpen }),
    ...(config && config.onClose && { onClose: config.onClose }),
    ...(config && config.autoClose && { autoClose: config.autoClose }),
  });
};

export const successToast = (evt, payload, msg, config) => {
  logInfo("toast", "successToast", { evt: evt, payload: payload, msg: msg });
  toast.success(msg, {
    ...defaultConfig,
    ...(config && config.toastId && { toastId: config.toastId }),
    ...(config && config.onOpen && { onOpen: config.onOpen }),
    ...(config && config.onClose && { onClose: config.onClose }),
    ...(config && config.autoClose && { autoClose: config.autoClose }),
  });
};

export const warnToast = (evt, payload, msg, config) => {
  logWarn("toast", "warnToast", { evt: evt, payload: payload, msg: msg });
  toast.warn(msg, {
    ...defaultConfig,
    ...(config && config.toastId && { toastId: config.toastId }),
    ...(config && config.onOpen && { onOpen: config.onOpen }),
    ...(config && config.onClose && { onClose: config.onClose }),
    ...(config && config.autoClose && { autoClose: config.autoClose }),
  });
};

export const errorToast = (evt, payload, msg, config) => {
  logError("toast", "errorToast", { evt: evt, payload: payload, msg: msg });
  toast.error(msg, {
    ...defaultConfig,
    ...(config && config.toastId && { toastId: config.toastId }),
    ...(config && config.onOpen && { onOpen: config.onOpen }),
    ...(config && config.onClose && { onClose: config.onClose }),
    ...(config && config.autoClose && { autoClose: config.autoClose }),
  });
};
